export const REDUCER_KEY = 'recipient-specific-block';
export const MEDIA_KEY = 'media';
